/**
 * Reseller rates tab — eagerly registers the file route; the page component and
 * its atom/RPC/design imports are deferred to `index.lazy.tsx` so they load only
 * with this route, never in the always-loaded `main` chunk (CLA-645).
 *
 * Nests under `admin_/resellers/route.tsx`, whose `requireAdmin` `beforeLoad`
 * gate already runs ahead of this screen — this route adds no auth check.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/resellers/$customerId/rates/")({});
